import { render, staticRenderFns } from "./DataApp.vue?vue&type=template&id=7c135cbd&scoped=true&"
import script from "./DataApp.vue?vue&type=script&lang=js&"
export * from "./DataApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c135cbd",
  null
  
)

export default component.exports